import { useState, useEffect } from 'react';
import DashboardLayout from '../../../../layouts/DashboardLayout';
import { TOAST_ERROR_IDS, TOAST_SUCCESS_IDS } from '../../../../interaces/toast.ids.interface';
import { CERTIFICATES_TYPES_TRANSLATED_TITLE } from '../../../../interaces/certificates_types.interface';
import toast from 'react-hot-toast';
import { reportsApi } from '../../api/reports.api';
import { useReports } from '../../hooks/useReports';
import { DataTable } from '../../../../components/DataTable/DataTable';
import { dowloadPdf } from '../../../../services/helpers';
import ReportDetailModal from '../../components/ReportDetailModal/ReportDetailModal';
import PdfViewerModal from '../../components/PdfViewerModal/PdfViewerModal';
import styles from '../../styles/styles.module.css';
import { ENUM_CERTIFICATES_STATUS } from '../../../emission/interfaces/certificates.interface';
import { formatCreatedAtToDate, formatCreatedAtToTime } from '../../../../services/helpers';
import { FaChevronUp, FaChevronDown, FaInfoCircle, FaDownload } from 'react-icons/fa';
import { KPI_CARDS } from '../../interfaces/report.interface';
function Reports() {
  const [openPdf, setOpenPdf] = useState(false);
  const [loadingPdf, setLoadingPdf] = useState(false);
  const {
    entities,
    fetchSearch,
    loading,
    searchValue,
    setSearchValue,
    onClear,
    dataPagination,
    setPageData,
    pageData,
    dataFilters,
    setDataFilters,
    endDate,
    setEndDate,
    startDate,
    setStartDate,
  } = useReports();

  const [openModal, setOpenModal] = useState(false);
  const [model, setModel] = useState(null);
  useEffect(() => {
    fetchSearch();
  }, []);

  function exportCSV() {
    const headers = [
      '#',
      'Folio',
      'Tipo de Certificado',
      'Titular / Razón Social',
      'CURP',
      'RFC',
      'Fecha de Emisión',
      'Hora de Emisión',
    ];
    const escapeCSV = (value) => {
      if (value === null || value === undefined) {
        return '';
      }

      return `"${String(value).replace(/"/g, '""')}"`;
    };

    const lines = entities.map((item, index) => {
      const date = new Date(item.createdAt);

      const fecha = date.toLocaleDateString('es-MX', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
      });

      const hora = date.toLocaleTimeString('es-MX', {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false,
      });
      const certificateType =
        CERTIFICATES_TYPES_TRANSLATED_TITLE[item.certificateType?.toLowerCase()] ||
        CERTIFICATES_TYPES_TRANSLATED_TITLE[item.certificateType] ||
        item.certificateType ||
        'N/A';

      return [index + 1, item.folio, certificateType, item.holder, item.curp, item.rfc, fecha, hora]
        .map(escapeCSV)
        .join(',');
    });

    const csv = [headers.map(escapeCSV).join(','), ...lines].join('\r\n');

    const blob = new Blob(['\uFEFF' + csv], { type: 'text/csv;charset=utf-8;' });

    const url = URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.download = 'auditoria.csv';

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    URL.revokeObjectURL(url);
  }
  const handleExportPdf = async () => {
    const toastId = toast.loading('Generando reporte PDF...', { id: 'generating-pdf' });
    try {
      await reportsApi.exportPdf(pageData);
      toast.success('Reporte PDF descargado correctamente.', { id: toastId });
    } catch (error) {
      toast.error(error.message || 'Error al generar el reporte PDF.', {
        id: toastId,
      });
    }
  };

  const kpiValues = {
    total: entities.length,
    validaciones: entities.filter((r) => (r.estado || 'VIGENTE') === 'VIGENTE').length,
  };
  //DataTable
  const [pdfBlobUrl, setPdfBlobUrl] = useState(null);

  const handleViewPdfModal = async () => {
    if (!model) return;
    setLoadingPdf(true);
    try {
      const blob = await reportsApi.downloadCertificatePdf(model.folio, model.tipo);
      const url = window.URL.createObjectURL(blob);
      setPdfBlobUrl(url);
      setOpenModal(false);
      setOpenPdf(true);
    } catch (error) {
      toast.error(error.message || TOAST_ERROR_IDS.SERVER_CONNECTION_ERROR, {
        id: TOAST_ERROR_IDS.SERVER_CONNECTION_ERROR,
      });
    } finally {
      setLoadingPdf(false);
    }
  };
  const handleDownload = async (report) => {
    try {
      const blob = await reportsApi.downloadCertificatePdf(report.folio, report.tipo);
      dowloadPdf(blob, report.tipo || 'certificado', report.folio);
      toast.success(TOAST_SUCCESS_IDS.CORRECT_DOWLOAD, { id: TOAST_SUCCESS_IDS.CORRECT_DOWLOAD });
    } catch (error) {
      toast.error(error.message || TOAST_ERROR_IDS.SERVER_CONNECTION_ERROR, {
        id: TOAST_ERROR_IDS.SERVER_CONNECTION_ERROR,
      });
    }
  };
  const handleDetails = (report) => {
    const tipoLabel =
      CERTIFICATES_TYPES_TRANSLATED_TITLE[report.tipo?.toLowerCase()] ||
      CERTIFICATES_TYPES_TRANSLATED_TITLE[report.tipo] ||
      (report.tipo ? report.tipo.charAt(0).toUpperCase() + report.tipo.slice(1).toLowerCase() : '');
    setModel({
      ...report,
      tipoLabel,
      fecha: report.fechaEmision
        ? new Date(report.fechaEmision).toLocaleDateString('es-MX')
        : 'N/A',
      usuario: 'Sistema',
      estado: report.estado || 'Vigente',
      observaciones: 'Certificado emitido.',
      pdf: null,
    });
    setOpenModal(true);
  };

  const columns = [
    {
      accessorKey: 'folio',
      header: 'FOLIO',
    },
    {
      accessorKey: 'certificateType',
      header: 'TIPO DE CERTIFICADO',
    },
    {
      accessorKey: 'holder',
      header: 'TITULAR',
    },
    {
      accessorKey: 'createdAt',
      header: ({ column }) => {
        const sorted = column.getIsSorted();

        return (
          <div className="date">
            <span>FECHA EMISIÓN</span>

            <div className="date-buttons">
              {/* ESTADO INICIAL O DESCENDENTE */}
              {sorted !== 'asc' && (
                <button
                  type="button"
                  onClick={() => column.toggleSorting(false)}

                  className="date-button"
                >
                  <FaChevronDown size={18} />
                </button>
              )}

              {/* ASCENDENTE */}
              {sorted === 'asc' && (
                <button
                  type="button"
                  onClick={() => column.toggleSorting(true)}
                  className="date-button"
                >
                  <FaChevronUp size={18} />
                </button>
              )}
            </div>
          </div>
        );
      },

      cell: ({ row }) => {
        const item = row.original;

        return (
          <div>
            <p>{formatCreatedAtToDate(item.createdAt)}</p>
            <p>{formatCreatedAtToTime(item.createdAt)}</p>
          </div>
        );
      },
    },
    {
      accessorKey: 'status',
      header: 'ESTADO',
      cell: ({ row }) => {
        const status = row.original.status;
        return (
          <span
            className={`
             status-register
             ${status == ENUM_CERTIFICATES_STATUS.VIGENTE ? 'status-color-vigente' : status == ENUM_CERTIFICATES_STATUS.VENCIDO ? 'status-color-vencido' : status == ENUM_CERTIFICATES_STATUS.REVOCADO ? 'status-color-revocado' : 'status-color-default '}
           `}
          >
            {status}
          </span>
        );
      },
    },
    {
      id: 'acciones',
      header: 'ACCIONES',
      cell: ({ row }) => {
        const item = row.original;
        return (
          <div className="others-buttons-actions">
            <button
              className="btn-action-view"
              onClick={() => handleDetails(item)}
              title="Ver validación"
            >
              <FaInfoCircle className="icon-button" />
            </button>
            <button
              className="btn-action-download"
              onClick={() => handleDownload(item)}
              title="Descargar PDF"
            >
              <FaDownload className="icon-button" />
            </button>
          </div>
        );
      },
    },
  ];

  return (
    <DashboardLayout>
      <div className="page-container">
        <div className="page-header-row print:hidden">
          <div className="page-title-wrapper">
            <p className="page-subtitle">Consulta y genera reportes de la operación del sistema.</p>
          </div>
        </div>

        <div className={styles.kpiGrid}>
          {KPI_CARDS.map(({ key, label, icon: Icon, colorClass }) => (
            <div key={key} className={styles.kpiCard}>
              <div className={`${styles.kpiIcon} ${colorClass}`}>
                <Icon />
              </div>
              <div className={styles.kpiInfo}>
                <span className={styles.kpiValue}>{loading ? '...' : kpiValues[key]}</span>
                <span className={styles.kpiLabel}>{label}</span>
              </div>
            </div>
          ))}
        </div>
        <DataTable
          columns={columns}
          data={entities}
          searchPlaceholder="Buscar reporte..."
          pageSize={4}
          loading={loading}
          emptyMessage="No hay registros"
          onRowClick={(data) => {}}
          showSearch={true}
          showPagination={true}
          onSearch={() => fetchSearch()}
          searchValue={searchValue}
          setSearchValue={setSearchValue}
          showCreate={false}
          setOpenModal={setOpenModal}
          onClear={() => onClear()}
          showFilters={true}
          dataFilters={dataFilters}
          setDataFilters={setDataFilters}
          numberFilters={3}
          showCalendar={true}
          startDate={startDate}
          endDate={endDate}
          setStartDate={setStartDate}
          setEndDate={setEndDate}
          showExportCsv={true}
          exportCSV={() => exportCSV()}
          showExportPdf={true}
          exportPdf={() => handleExportPdf()}

          dataPagination={dataPagination}
          setPageData={setPageData}
          pageData={pageData}
        />
        {openModal && (
          <ReportDetailModal
            open={openModal}
            report={model}
            onClose={() => setOpenModal(false)}
            onViewPdf={handleViewPdfModal}
            onDownloadPdf={() => model && handleDownload(model)}
            loadingPdf={false}
          />
        )}
        {openPdf && <PdfViewerModal onClose={() => setOpenPdf(false)} pdfUrl={pdfBlobUrl} />}
      </div>
    </DashboardLayout>
  );
}

export default Reports;
